webpackJsonp([64849619966374],{

/***/ 421:
/***/ (function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	var D1 = "https://bawaindustries.com/assets/images/Infographic/BI1.png";
	var D2 = "https://bawaindustries.com/assets/images/Infographic/BI2.png";
	var D3 = "https://bawaindustries.com/assets/images/Infographic/BI3.png";
	var D4 = "https://bawaindustries.com/assets/images/Infographic/BI4.png";
	var D5 = "https://bawaindustries.com/assets/images/Infographic/BI5.png";
	var D6 = "https://bawaindustries.com/assets/images/Infographic/BI6.png";
	var D7 = "https://bawaindustries.com/assets/images/Infographic/BI7.png";
	var D8 = "https://bawaindustries.com/assets/images/Infographic/BI8.png";
	var D9 = "https://bawaindustries.com/assets/images/Infographic/BI9.png";
	var D10 = "https://bawaindustries.com/assets/images/Infographic/BI10.png";
	
	var col1 = exports.col1 = [{
		text: "Legacy of over six decades of excellence in production of premium spices and spice blends",
		imgSrc: D1
	}, {
		text: "Traditional recipe blends, made even better through constant innovation.",
		imgSrc: D2
	}, {
		text: "State-of-art technology with the finest machinery.",
		imgSrc: D3
	}, {
		text: "Best manufacturing processes and standard in the industry.",
		imgSrc: D4
	}, {
		text: "Premium quality, with an international reputation.",
		imgSrc: D5
	}, {
		text: "Fumigation to keep the quality of the product intact and increase shelf life.",
		imgSrc: D6
	}, {
		text: "Unparallelled cleaning and processing capacity ",
		imgSrc: D7
	}, {
		text: "Best in class marketing support and highly trained sales staff",
		imgSrc: D8
	}, {
		text: "Attractive trade schemes for dealers and stockists",
		imgSrc: D9
	}, {
		text: "High customer satisfaction, confidence and continuous quality improvement ",
		imgSrc: D10
	}];

/***/ }),

/***/ 110:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 611:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ }),

/***/ 468:
/***/ (function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.Legacy = undefined;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(110);
	
	var _contentPage = __webpack_require__(29);
	
	var _contentPage2 = _interopRequireDefault(_contentPage);
	
	var _meta = __webpack_require__(33);
	
	var _meta2 = _interopRequireDefault(_meta);
	
	var _propTypes = __webpack_require__(2);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _axios = __webpack_require__(38);
	
	var _axios2 = _interopRequireDefault(_axios);
	
	var _sweetalert = __webpack_require__(49);
	
	var _sweetalert2 = _interopRequireDefault(_sweetalert);
	
	var _regex = __webpack_require__(46);
	
	var _Heading = __webpack_require__(25);
	
	var _Heading2 = _interopRequireDefault(_Heading);
	
	__webpack_require__(611);
	
	var _legacyConstant = __webpack_require__(421);
	
	var _reactFacebookPixel = __webpack_require__(31);
	
	var _reactFacebookPixel2 = _interopRequireDefault(_reactFacebookPixel);
	
	var _gatsbyConfig = __webpack_require__(24);
	
	var _reactAnimateOnScroll = __webpack_require__(115);
	
	var _reactAnimateOnScroll2 = _interopRequireDefault(_reactAnimateOnScroll);
	
	__webpack_require__(85);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var DarjiLogo = "https://bawamasalacompany.com/assets/images/Elements/S_Bawa_Sardar_Singh_Bhalla.png";
	
	var duration = 400;
	
	var Legacy = exports.Legacy = function (_React$Component) {
	  _inherits(Legacy, _React$Component);
	
	  function Legacy(args) {
	    _classCallCheck(this, Legacy);
	
	    var _this = _possibleConstructorReturn(this, _React$Component.call(this, args));
	
	    _this.handleChangeAndValidation = function (key, e) {
	      var _extends2;
	
	      var Error = _this.state.Error;
	
	      _this.setState({
	        values: _extends({}, _this.state.values, (_extends2 = {}, _extends2[key] = e.target.value.trim(), _extends2))
	      });
	      delete Error[key];
	    };
	
	    _this.handleSubmit = function () {
	      var values = _this.state.values;
	
	      var isFlag = false;
	      var error = {};
	      // eslint-disable-next-line
	      _this.inputs.map(function (item) {
	        if (!values[item] && item !== "Message") {
	          isFlag = true;
	          error[item] = true;
	        } else if (item === "Email") {
	          error[item] = !(0, _regex.validationForEmail)(values[item]);
	          isFlag = isFlag === true ? true : error[item];
	        }
	      });
	      var params = "username=" + values.Name + "&\n\t\t\t\t\temail=" + values.Email + "&\n\t\t\t\t\tmsg=" + values.Message + "&\n\t\t\t\t\tphone=" + values.Phn;
	      if (isFlag) {
	        _this.setState({
	          Error: error
	        });
	      } else {
	        (0, _sweetalert2.default)({
	          title: "Submitting Request...",
	          onOpen: function onOpen() {
	            _sweetalert2.default.showLoading();
	          }
	        });
	        _axios2.default.post("https://blackelephantdigital.in/blackele/sunny/api/bmc-api/public/connect?" + params).then(function (response) {
	          _sweetalert2.default.close();
	          (0, _sweetalert2.default)({
	            title: "Successfully Submitted",
	            html: "<div style='text-align: center'>Thank you for getting in touch!</div>",
	            type: "success"
	          });
	          return response;
	        }).catch(function (e) {
	          (0, _sweetalert2.default)({
	            title: "Warning",
	            html: "<div style='text-align: center'>Internal Server error</div>",
	            type: "error"
	          });
	        });
	      }
	    };
	
	    _this.inputs = ["Name", "Email", "Message", "Phn"];
	    _this.state = {
	      isLoading: true,
	      Error: {},
	      values: {},
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0
	      }
	    };
	    return _this;
	  }
	
	  Legacy.prototype.componentDidMount = function componentDidMount() {
	    var _this2 = this;
	
	    _reactFacebookPixel2.default.init(_gatsbyConfig.siteMetadata.facebookId);
	    _reactFacebookPixel2.default.track("ViewContent", location);
	    setTimeout(function () {
	      _this2.setState({
	        defaultStyle: {
	          transition: "opacity " + duration + "ms ease-in-out",
	          opacity: 1
	        }
	      });
	    }, 500);
	  };
	
	  Legacy.prototype.componentWillUnmount = function componentWillUnmount() {
	    this.setState({
	      showTrans: true,
	      defaultStyle: {
	        transition: "opacity " + duration + "ms ease-in-out",
	        opacity: 0.1
	      }
	    });
	  };
	
	  Legacy.prototype.render = function render() {
	    var location = this.props.location;
	    var defaultStyle = this.state.defaultStyle;
	
	    return _react2.default.createElement(
	      _contentPage2.default,
	      null,
	      _react2.default.createElement(_meta2.default, {
	        title: "Bawa Industries Legacy",
	        description: "An offshoot of Bawa Masala Company (BMC), estd. 1952, Bawa Industries has a legacy of over seven decades in spice manufacturing and trading.",
	        location: location
	      }),
	      _react2.default.createElement(
	        "div",
	        { className: "global__wrapper" },
	        _react2.default.createElement(
	          "div",
	          { className: "legacy__wrapper", style: defaultStyle },
	          _react2.default.createElement(_Heading2.default, { title: "Bawa Legacy and The Taste of Tradition" }),
	          _react2.default.createElement(
	            "div",
	            { className: "panel__1" },
	            _react2.default.createElement(
	              "div",
	              { className: "row __media" },
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-3 __media__left" },
	                _react2.default.createElement(
	                  _reactAnimateOnScroll2.default,
	                  { delay: 0, duration: 0, animateIn: "zoomIn", offset: 250 },
	                  _react2.default.createElement("img", { src: DarjiLogo, alt: "S_Bawa_Sardar Singh_Bhalla", className: "img img-responsive" }),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "name" },
	                    "S.Bawa Sardar Singh Bhalla"
	                  ),
	                  _react2.default.createElement(
	                    "div",
	                    { className: "founder" },
	                    "Founder of Bawa Masala Company"
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "col-md-9 __media__body" },
	                _react2.default.createElement(
	                  _reactAnimateOnScroll2.default,
	                  { delay: 0, duration: 0, animateIn: "bounceInRight", offset: 250 },
	                  "Bawa Brand Masale, established over two decades ago, is a renowned name in premium spice products, and an offshoot of the masala giant, Bawa Masala Company (BMC), with a legacy of over nearly seven decades of expertise in spice and spice blends.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  "After starting in 1952, on a humble note, with a small unit having a capacity to produce merely four basic spices, BMC, thanks to the firm commitment to deliver quality, is a leader in the spice industry, and at the forefront of the domestic and international market with an emphasis on premium quality, constant innovation and consistent delivery on timeless recipes and taste.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  "For good reason. Before hitting the shelf at the outlets, each hygienically produced BMC and Bawa Brand Masale product undergoes stringent quality tests and is packed to keep the freshness and wholesomeness intact for the consumer. Our hi-tech production plant and diligent supervision at each stage during the production process ensure the quality that is a hallmark of BMC, and Bawa Brand Masale.",
	                  _react2.default.createElement("br", null),
	                  _react2.default.createElement("br", null),
	                  "Our products offer a vast range of variety, tickling the taste buds of every food lover."
	                )
	              )
	            )
	          ),
	          _react2.default.createElement(
	            "div",
	            { className: "panel__2" },
	            _react2.default.createElement(_Heading2.default, { title: "Infrastructure, expertise and process", size: "large" }),
	            _react2.default.createElement(
	              "div",
	              { className: "content" },
	              _react2.default.createElement(
	                "div",
	                { className: "sub__heading" },
	                "Bawa Industries has international standard infrastructure, well-poised to meet the daily rigours of global demand for premium Indian spices"
	              ),
	              _react2.default.createElement(
	                "div",
	                { className: "row" },
	                _react2.default.createElement(
	                  _reactAnimateOnScroll2.default,
	                  { delay: 0, duration: 0, animateIn: "bounceInLeft", offset: 250 },
	                  _legacyConstant.col1.map(function (item, i) {
	                    return _react2.default.createElement(
	                      "div",
	                      { className: "col-sm-12 infographics", key: i },
	                      _react2.default.createElement(
	                        "div",
	                        { className: "info" },
	                        _react2.default.createElement(
	                          "div",
	                          { className: "info-img" },
	                          _react2.default.createElement("img", { src: item.imgSrc, alt: item.text, className: "" })
	                        ),
	                        _react2.default.createElement(
	                          "div",
	                          { className: "info-text" },
	                          item.text
	                        )
	                      )
	                    );
	                  })
	                )
	              )
	            )
	          )
	        )
	      )
	    );
	  };
	
	  return Legacy;
	}(_react2.default.Component);
	
	Legacy.propTypes = {
	  location: _propTypes2.default.object
	};
	
	exports.default = Legacy;

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-legacy-index-js-c01c65c119e29cb99d8b.js